import { ActorInvitationReason } from "./ActorInvitation";

type ActorInvitationReasonWithTranslation = Omit<
  Record<ActorInvitationReason, string>,
  ActorInvitationReason.UNSUPPORTED_ACTOR_TYPE_FOR_INVITATION
>;

export const ACTOR_INVITATION_REASON_TO_TRANSLATION_KEY: ActorInvitationReasonWithTranslation = {
  [ActorInvitationReason.DISABLED_BY_POLICY]:
    "documentation_area.actor_invitation.reason.disabled_by_policy",
  [ActorInvitationReason.MAX_TOTAL_ACTORS_REACHED]:
    "documentation_area.actor_invitation.reason.max_total_actors_reached",
};

/**
 * Get the translation key for a given actor invitation reason.
 * Returns null if no reason is provided.
 */
export const getActorInvitationReasonTranslationKey = (
  reason: ActorInvitationReason | null | undefined,
): string | null => {
  if (!reason || reason === ActorInvitationReason.UNSUPPORTED_ACTOR_TYPE_FOR_INVITATION) {
    return null;
  }

  return ACTOR_INVITATION_REASON_TO_TRANSLATION_KEY[reason] ?? null;
};
